import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@utex/ui-kit';
import { GroupPanel } from '@utex/ui-kit/desktop';
import { getExtraDimHeaderButton, getPrimaryDimHeaderButton } from '../HeaderButtons/buttonsView';
import { headerButtonPadding } from './styles';
export var Authentication = function (props) {
    var t = useTranslation('header').t;
    var onLogin = props.onLogin, onRegistration = props.onRegistration, view = props.view;
    return (React.createElement(GroupPanel, null,
        React.createElement(Button, { view: getExtraDimHeaderButton(view), isBlured: view !== 'default', css: headerButtonPadding, onClick: function () {
                onLogin();
            }, "data-testid": "header-signin-btn", "data-gtm": "header-signin-btn" }, t('Login')),
        React.createElement(Button, { view: getPrimaryDimHeaderButton(view), isBlured: view !== 'default', css: headerButtonPadding, onClick: function () {
                onRegistration();
            }, "data-testid": "header-signup-btn", "data-gtm": "header-signup-btn" }, t('Registration'))));
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Authentication/index.js
// module id = 1357
// module chunks = 118